import { tgxApi } from "../../../app/tgxApi";
import {
    handleQueryError,
} from "../../../helpers/utils/RtkQueryUtils";
import { serialize } from "../../../helpers/utils/Utils";

export const externalApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({
        getAllExternalStates: build.query({
            query: () => {
                return {
                    url: `/external/get-all-states`,
                    method: 'GET',
                };
            },
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getAllExternalCountyByStateAbbr: build.query({
            query: (stateAbbreviation) => {
                return {
                    url: `/external/county-by-state/${stateAbbreviation}`,
                    method: 'GET'
                };
            },
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        searchExternalBillReleases: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/external/billReleases?${paramData}`,
                    method: 'POST',
                };
            },
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled);
            },
        }),

    }),
});


export const {
    useGetAllExternalStatesQuery,
    useSearchExternalBillReleasesQuery,
    useLazyGetAllExternalCountyByStateAbbrQuery
} = externalApi;